import './styles.scss'

import { useTranslation } from "react-i18next"
import * as Material from "@mui/material"
import { BrowseGalleryRounded, PlayCircleOutlineRounded, SettingsRounded } from "@mui/icons-material"
import { UserAvatar } from "@components/Community"
import Parser from "@helpers/parser"

import { Text } from "@fragments"

export default function SingleLesson({ content, handleOpenContent, handleOpenEdit }) {
    const { t } = useTranslation("content")

    const isFutureDate = (dateString) => {
        if (!dateString) return false;
        const date = new Date(dateString);
        const now = new Date();
        return date > now;
    };
    const isHorizontal = content.video?.aspect_ratio > 1

    return (
        <div
            className="single-lesson-container mt-2 mb-5"
            onClick={() => handleOpenContent(content)}
        >
            <div
                className={"lesson-banner " + (isHorizontal ? "horizontal" : "vertical")}
                style={{
                    aspectRatio: content.video?.aspect_ratio,
                }}
            >
                <img src={content.banner} alt={content.name} style={!content.availability?.available ? { filter: 'grayscale(100%)' } : undefined} />
                <div className="lesson-overlay">
                    <PlayCircleOutlineRounded className="play-lesson" />
                    <div className="description">
                        <span className="lesson-title">{content.name}</span>
                    </div>
                </div>

                {/* Settings button for editing lesson - only visible when editing is enabled and user is admin */}
                {handleOpenEdit && (
                    <Material.IconButton
                        className="lesson-settings-button"
                        onClick={(e) => {
                            e.stopPropagation()
                            handleOpenEdit(content)
                        }}
                        size="small"
                    >
                        <SettingsRounded color="white" fontSize="small" />
                    </Material.IconButton>
                )}
            </div>

            <div className="lesson-info">
                {isFutureDate(content.availability?.available_at) && (
                    <Text.span left={<BrowseGalleryRounded />} className="pb-1" contrast={6}>
                        {t('card.availableAt', { date: Parser.date.readable(content.availability.available_at) })}
                    </Text.span>
                )}
                <Text.h3 contrast={8}>{content.name}</Text.h3>
                <Text.span contrast={5} weight={300}>{content.description}</Text.span>
                {content.creator?.id && (
                    <div className="lesson-owner">
                        <UserAvatar size={20} user={content.creator} displayName={true} />
                        <span style={{ transform: "translateY(1px)" }}></span>
                    </div>
                )}
            </div>
        </div>
    )
}
